import { BrazeCustomEvents, initBraze } from "shared-services";
import {
  getUser as brazeGetUser,
  logCustomEvent as brazeLogCustomEvent,
} from "@braze/web-sdk";
import { ICDApplication } from "../../../services/online-application.types";
import {
  WelcomePageFormFields,
  welcomePageFormInitialFields,
} from "./WelcomePageCD/welcomePageValidation";
import { aboutYouInitialFormValues } from "./AboutYouPageCD/constants";
import { cdBrazeProps, ICDApplicationPage, ICDFormValues } from "./constants";

export const mapCDFormData = (applicationCD: ICDApplication): ICDFormValues => {
  const welcomeFrom: WelcomePageFormFields = {
    firstNameCD:
      applicationCD.forename || welcomePageFormInitialFields.firstNameCD,
    secondNameCD:
      applicationCD.surname || welcomePageFormInitialFields.secondNameCD,
    mobileNumberCD:
      applicationCD.mobile || welcomePageFormInitialFields.mobileNumberCD,
    landlineNumberCD:
      applicationCD.phone || welcomePageFormInitialFields.landlineNumberCD,
    emailCD: applicationCD.email || welcomePageFormInitialFields.emailCD,
    occupation:
      applicationCD.occupationLookUpId ||
      welcomePageFormInitialFields.occupation,
    companyName:
      applicationCD.company || welcomePageFormInitialFields.companyName,
    companyWebsite:
      applicationCD.website || welcomePageFormInitialFields.companyWebsite,
    memberOfProfessionalOrg: applicationCD.organisationLookUpId ? "yes" : "no",
    professionalOrgMembershipType:
      String(applicationCD.organisationLookUpId) ||
      welcomePageFormInitialFields.professionalOrgMembershipType,
    professionalOrgMembershipName:
      applicationCD.membershipName ||
      welcomePageFormInitialFields.professionalOrgMembershipName,
    professionalOrgMembershipEmail:
      applicationCD.membershipEmail ||
      welcomePageFormInitialFields.professionalOrgMembershipEmail,
    professionalOrgMembershipNumber:
      applicationCD.membershipNumber ||
      welcomePageFormInitialFields.professionalOrgMembershipNumber,
    hadSpotlightAccount: applicationCD.previousSpotlightMemberName
      ? "yes"
      : "no",
    existingSpotlightAccName:
      applicationCD.previousSpotlightMemberName ||
      welcomePageFormInitialFields.existingSpotlightAccName,
    existingSpotlightAccMembershipType:
      applicationCD.previousSpotlightMemberType ||
      welcomePageFormInitialFields.existingSpotlightAccMembershipType,
    existingSpotlightAccEmail:
      applicationCD.previousSpotlightMemberRegisteredEmail ||
      welcomePageFormInitialFields.existingSpotlightAccEmail,
    termsAgree: true,
    street1: applicationCD?.addressInfo?.street1,
    street2: applicationCD?.addressInfo?.street2,
    city: applicationCD?.addressInfo?.city,
    postal_code: applicationCD?.addressInfo?.postal_code,
    country: applicationCD?.addressInfo?.country,
    state_province: applicationCD?.addressInfo?.state_province,
  };

  const aboutYouFrom = {
    experience:
      applicationCD.experience || aboutYouInitialFormValues.experience,
    cdCV: applicationCD.cvS3ObjectKey || aboutYouInitialFormValues.cdCV,
    linkURL: applicationCD.links || aboutYouInitialFormValues.linkURL,
    castingForUnder18: applicationCD.castingForUnder18 ? "yes" : "no",
    castingForUnder18Aware: applicationCD.castingForUnder18Aware ? "yes" : "no",
    usingFor:
      String(applicationCD.useSpotlightForLookUpId) ||
      aboutYouInitialFormValues.usingFor,
    aboutYou:
      applicationCD.useSpotlightForNotSureDetails ||
      aboutYouInitialFormValues.aboutYou,
  };

  return {
    [ICDApplicationPage.Welcome]: welcomeFrom,
    [ICDApplicationPage.AboutYouPage]: aboutYouFrom,
  };
};

export function trackCDJoiningStart(userEmail: string) {
  try {
    const isBrazeInitialized = initBraze(cdBrazeProps);

    if (!isBrazeInitialized) {
      throw new Error("Failed to initialize Braze");
    }

    brazeGetUser()?.setEmail(userEmail);
    brazeLogCustomEvent(BrazeCustomEvents.CDJoiningStarted, {
      reg_started: true,
      reg_start_date: new Date().toISOString(),
    });
  } catch (error) {
    console.error("Failed to Log Custom Event to Braze: ", error);
  }
}

export function trackCDJoiningComplete(userEmail: string) {
  try {
    brazeGetUser();
  } catch (error: any) {
    console.error("Failed to get Braze User: ", error);
    try {
      const isBrazeInitialized = initBraze(cdBrazeProps);

      if (!isBrazeInitialized) {
        throw new Error("Failed to initialize Braze");
      }

      brazeGetUser()?.setEmail(userEmail);
    } catch (error: any) {
      console.error("Failed to Log Custom Event to Braze: ", error);
    }
  }

  brazeLogCustomEvent(BrazeCustomEvents.CDJoiningCompleted, {
    reg_completed: true,
    reg_completed_date: new Date().toISOString(),
  });
}
